import { Box } from "@mui/material";
import { ParagraphText } from "../../../../Libraries";
import { getInitials } from "../../../../utils";
import { analytics, triggerLogEvent } from "../../../../config/firebase";
import styles from "./TransactionListing.module.css";

const ContactRow = ({ item, onViewDetail, onAddContact }) => {
  const { display_name, has_customer, customer_phone, total_txns } = item;

  const initials = has_customer ? getInitials(display_name || "?") : "#";

  return (
    <Box
      id={`transaction_listing_contact_row_${item.customer_id || customer_phone}`}
      className="invoiceListTableBody accountTableHeaderMain pointer"
      onClick={() => onViewDetail(item)}
    >
      <Box className={`invListTableHeaderCol fourColumn textLeft ${styles.contactCell}`}>
        <Box className={styles.avatarCircle}>{initials}</Box>
        <ParagraphText className={`fontSize14 fontWeight400 truncateOneLine newFontColor ${styles.contactName}`}>
          {display_name || customer_phone || "-"}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fourColumn textLeft">
        {customer_phone && display_name ? (
          <ParagraphText className="fontSize14 fontWeight400 newLightColor">
            {customer_phone}
          </ParagraphText>
        ) : (
          <ParagraphText
            id={`transaction_listing_contact_row_add_contact_btn_${item.customer_id || customer_phone}`}
            className="fontSize14 fontWeight400 newLightColor textDecorationUnerline pointer"
            onClick={(e) => {
              e.stopPropagation();
              triggerLogEvent(analytics, "w_bill_txn_add_contact");
              onAddContact?.(item);
            }}
          >
            Add contact
          </ParagraphText>
        )}
      </Box>

      <Box className="invListTableHeaderCol fourColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {total_txns ?? "-"}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fourColumn justifyCenter">
        <ParagraphText className={styles.viewDetailBtn}>
          View details 
        </ParagraphText>
      </Box>
    </Box>
  );
};

export default ContactRow;
